// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const multiColumCards = document.querySelectorAll('.multi-column-cards-section');

    multiColumCards.forEach(section => {
        const cardSlider = section.querySelectorAll('.mccs-carousel');

        if (cardSlider.length > 0) {
            cardSlider.forEach(slider => {
                const slidesPerView = parseInt(slider.getAttribute('data-slides'), 10) || 1;

                // Define base config
                const mccsswiperConfig = {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 32,
                    navigation: {
                        prevEl: section.querySelector('.mccs-button-prev'),
                        nextEl: section.querySelector('.mccs-button-next'),
                    },
                    breakpoints: {},
                };

                // Add responsive settings based on data-slides value
                if (slidesPerView === 2) {
                    mccsswiperConfig.breakpoints = {
                        576: {
                            slidesPerView: 2,
                        },
                    };
                } else if (slidesPerView === 3) {
                    mccsswiperConfig.breakpoints = {
                        576: {
                            slidesPerView: 2,
                        },
                        992: {
                            slidesPerView: 3,
                        },
                    };
                } else {
                    mccsswiperConfig.breakpoints = {
                        576: {
                            slidesPerView: 2,
                        },
                        992: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        },
                    };
                }

                new Swiper(slider, mccsswiperConfig);
            });
        }
    });
});